import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { ManageModule } from '@vendasta/notifications';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { ListComponent } from './list.component';
import { CreateComponent } from './create.component';
import { EditComponent } from './edit.component';
import { ReleaseComponent } from './release.component';
import { I18nGuideModalComponent } from './i18n-guide-modal.component';

@NgModule({
  declarations: [ListComponent, CreateComponent, EditComponent, ReleaseComponent],
  exports: [ListComponent, CreateComponent, EditComponent, ReleaseComponent],
  imports: [
    BrowserModule,
    ManageModule,
    GalaxyPageModule,
    MatButtonModule,
    MatDialogModule,
    GalaxyAlertModule,
    RouterModule,
    I18nGuideModalComponent,
  ],
})
export class NotificationsModule {}
